import { generateApiPath } from "@routes/generatePath";

const pathBase = `/reports/all-patients/`;

export const allPatients = {
  get: () => generateApiPath(pathBase),
};
